import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  tabWrapper: {
    color: theme.palette.primary.main,
    width: "100%",
    "& .MuiTabs-root": {
      width: "100%"
    },
    "& .MuiTabs-scroller": {},
    "& .MuiTabs-scrollButtons": {
      width: theme.spacing(0)
    }
  },
  tab: {
    flexGrow: 1,
    fontSize: ({ iconSize }) => theme.spacing(iconSize / 8),
    textTransform: "none"
  },
  selectedTab: {
    transition: `all ${theme.transitions.duration.short} ${theme.transitions.easing.easeIn}`,
    marginBottom: theme.spacing(-1)
  },
  unselectedTab: {
    transition: `all ${theme.transitions.duration.short} ${theme.transitions.easing.easeIn}`,
    marginBottom: theme.spacing(-1),
    color: theme.palette.text.mildLight
  },

  tabPanel: {
    width: "100%",
    height: "85%"
  }
}));
